import React from 'react';

export interface CoverageSnackbarProps {
    message?: string;
    onReachOut?: () => void;
}

const CoverageSnackbar: React.FC<CoverageSnackbarProps> = ({
    message = 'Request that Stackline add coverage for the retailers highlighted above',
    onReachOut
}) => {
    const [sent, setSent] = React.useState(false);

    const handleClick = async () => {
        if (sent) return;
        if (onReachOut) {
            await onReachOut();
            setSent(true);
            return;
        }
        try {
            window.open('mailto:support@stackline.com?subject=Retailer%20Coverage%20Request', '_blank');
            setSent(true);
        } catch { }
    };

    return (
        <div
            role="status"
            aria-live="polite"
            style={{
                background: '#FFDDDB',
                borderRadius: 4,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 16px',
                minHeight: 44,
                marginBottom: 56
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span aria-hidden="true" style={{ display: 'inline-flex', width: 24, height: 24 }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="9" fill="#FF534A" />
                        <path d="M8 8 L16 16 M16 8 L8 16" stroke="white" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </span>
                <div style={{ color: '#031425', fontSize: 14, fontWeight: 500, lineHeight: '20px' }}>{message}</div>
            </div>
            <button
                onClick={handleClick}
                disabled={sent}
                style={{
                    background: sent ? '#F1A9A5' : '#FF534A',
                    color: '#FFFFFF',
                    border: 'none',
                    borderRadius: 4,
                    height: 36,
                    padding: '10px 16px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 10,
                    margin: '10px 0',
                    fontWeight: 700,
                    fontSize: 14,
                    cursor: sent ? 'not-allowed' : 'pointer',
                    opacity: sent ? 0.6 : 1
                }}
                title={sent ? 'Request already sent' : 'Send request'}
            >
                {sent ? 'Request Sent' : '+ Reach Out'}
            </button>
        </div>
    );
};

export default CoverageSnackbar;


